import React from 'react'

const Reward=()=> {
  return (
    <>
   <section id='Reward' className=''>

   
    <div className='container my-3 '>
        <div className='row'>
            <h2 style={{color:'WindowFrame',textAlign:'center'}}>Reward & Recognition</h2>
        </div>
        <div className='row'>
            <div className='col-md-4'>
            <img src='https://fundguard.in/img1/g1.jpeg' alt=''/>

            </div>
            <div className='col-md-4'>
            <img src='https://fundguard.in/img1/g6.jpeg' alt=''/>

            </div>
            <div className='col-md-4'>
            <img src='https://fundguard.in/img1/g3.jpeg' alt=''/>

            </div>
           
        </div>
      
    </div>
    </section>
    </>
  );
};

export default Reward
